// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__CSMtN","dashboard_statistics_container":"dashboard_dashboard_statistics_container__FpBP3"};